module.exports = __webpack_public_path__ + "img/HERO-head-01-hanura.20913304.png";